import copy from 'copy-to-clipboard';
import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ButtonProps } from '@bonusly/design-system';

type CopyButtonProps = ButtonProps & {
	text: string;
};

export const CopyButton: FC<CopyButtonProps> = ({ text, ...rest }) => {
	const { t } = useTranslation('components', { keyPrefix: 'copy_button' });
	const [copied, setCopied] = useState(false);
	const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

	const handleCopy = () => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		copy(text);
		setCopied(true);
		timeoutRef.current = setTimeout(() => setCopied(false), 2000);
	};

	useEffect(() => {
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, []);

	return (
		<Button flexShrink={0} variant="alpha" colorScheme="secondary" size="xs" px={2} {...rest} onClick={handleCopy}>
			{copied ? t('copied') : t('copy')}
		</Button>
	);
};
